import './bootstrap';
import 'jquery'
import 'select2'

window.jQuery = window.$ = $

$(document).ready(function() {
    let typingTimer;                //timer identifier
    let doneTypingInterval = 2000;  //time in ms, 5 seconds for example
    let $input = $('#other_name');
    $('.js-example-basic-single').select2({});
    $("#name").on('change',function (){
        let name=$(this).val();
        if(name=="other"){
            $("#other_div").removeClass('d-none');
        }else{
            $("#other_div").addClass('d-none');
            reloadVideo();
        }
    });
    $("#age").on('change',function (){
        reloadVideo();
    });
    $("#country").on('change',function (){
        reloadVideo();
    });
    $input.on('keyup', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });
    $input.on('keydown', function () {
        clearTimeout(typingTimer);
    });
    function doneTyping () {
        reloadVideo();
    }
    function reloadVideo(){
        let age=$("#age").val();
        let name=$("#name").val();
        if(name=="other"){
            name=$("#other_name").val();
        }
        if(age=="18-39") age="39";
        else age="40";
        let country=$("#country").val();
        if(!name) name="other";
            let url=main_video_url+'?name='+name+'&lang='+lang+'&country='+country+'&age='+age;
            $("#video").attr('src',url);
    }
    reloadVideo();
});



